import { createContext, useContext, useState, useEffect } from 'react';
import Globals from '../config/globals';

const ImpersonationContext = createContext();

export function ImpersonationProvider({ children }) {
  const [isImpersonating, setIsImpersonating] = useState(false);
  const [impersonatedUser, setImpersonatedUser] = useState(null);
    const [realUser, setRealUser] = useState(null);

  useEffect(() => {
    const savedImpersonation = sessionStorage.getItem('impersonation');
    const savedRealUser = sessionStorage.getItem('realUser');
    if (savedImpersonation) {
      try {
        const { isActive, user } = JSON.parse(savedImpersonation);
        setIsImpersonating(isActive);
        setImpersonatedUser(user);
        Globals.userInfo = user?.user;
        if (savedRealUser) {
          setRealUser(JSON.parse(savedRealUser));
        } else {
          setRealUser(null);
        }
      } catch (error) {
        console.error('Failed to parse impersonation data:', error);
        sessionStorage.removeItem('impersonation');
        sessionStorage.removeItem('realUser');
        setIsImpersonating(false);
        setImpersonatedUser(null);
        setRealUser(null);
      }
    }
  }, []);

  const startImpersonation = (user, realUser) => {
    setIsImpersonating(true);
    setImpersonatedUser(user);
    setRealUser(realUser);

    Globals.userInfo = user.user;

    sessionStorage.setItem('impersonation', JSON.stringify({
      isActive: true,
      user: user
    }));

    sessionStorage.setItem('realUser', JSON.stringify(realUser));
  };

  const stopImpersonation = () => {
    setIsImpersonating(false);
    setImpersonatedUser(null);
    sessionStorage.removeItem('impersonation');
    sessionStorage.removeItem('realUser');
  };

  return (
    <ImpersonationContext.Provider value={{
      isImpersonating,
      impersonatedUser,
      startImpersonation,
      stopImpersonation,
      realUser
    }}>
      {children}
    </ImpersonationContext.Provider>
  );
}

export function useImpersonation() {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error('useImpersonation must be used within ImpersonationProvider');
  }
  return context;
}